import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';

StationInfoBoxView.propTypes = {
  station: PropTypes.object,
  onClicked: PropTypes.func,
};

function StationInfoBoxView({ station, onClicked }) {
  const statusName = ChargeHelper.Utils.getChargeStationStatusName(station?.status);
  const statusFontSize = statusName.length > 16 ? '10px' : '12px';
  const acPoints = _.filter(
    station?.chargePoints,
    (item) => item?.chargeModel?.type === ChargeConstants.ChargePointType.AC
  );
  const dcPoints = _.filter(
    station?.chargePoints,
    (item) => item?.chargeModel?.type === ChargeConstants.ChargePointType.DC
  );
  return (
    <div
      style={{
        maxWidth: '300px',
      }}
      className={`${onClicked ? 'cursor-pointer hover-opacity-80' : ''}`}
      onClick={onClicked}
    >
      <div
        className="bg-white overflow-hidden shadow"
        style={{
          borderRadius: '10px',
        }}
      >
        {/* anh tram sac */}
        <div
          className=""
          style={{
            width: '300px',
            aspectRatio: '320/170',
          }}
        >
          <img
            className="w-100 h-100"
            style={{
              objectFit: 'cover',
            }}
            src={
              Utils.isValid(station?.image)
                ? Utils.getFullUrl(station?.image)
                : AppResource.images.chargeConnectorTypes.imgChargeStationDefault
            }
            alt={station?.name}
          />
        </div>
        {/* ten tram sac */}
        <div className={`d-flex flex-column gap-1 p-4`}>
          <span style={UIHelper.buildFontStyle('600', '16px', 'rgba(73, 73, 104, 1)')}>
            {station?.name}
          </span>
          <div className="d-flex align-items-center gap-2" style={{ minWidth: 0 }}>
            <div style={{ flexShrink: 1, minWidth: 0, overflow: 'hidden' }}>
              <KTLabel
                text={statusName}
                isInline={true}
                isPill={false}
                size={KTLabelSize.medium}
                additionalClassName={`label-light-${ChargeHelper.Utils.getChargeStationStatusColor(
                  station?.status
                )}`}
                style={{
                  borderRadius: '4px',
                  padding: '13px 6px',
                  fontWeight: '600',
                  fontSize: statusFontSize,
                }}
              />
            </div>
            <div
              className="d-flex flex-row overflow-hidden"
              style={{
                width: '70px',
                height: '26px',
                borderRadius: '8px',
                border: '1px solid #DBDFF1',
                flexShrink: 0,
              }}
            >
              <div
                style={{
                  ...UIHelper.buildFontStyle('500', '14px', '#72728B'),
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flex: 1,
                }}
              >
                AC
              </div>
              <div
                style={{
                  ...UIHelper.buildFontStyle('600', '14px', '#fff'),
                  backgroundColor: 'rgba(48, 189, 111, 1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flex: 1,
                }}
              >
                {`${acPoints?.length}/${acPoints?.length}`}
              </div>
            </div>
            <div
              className="d-flex flex-row overflow-hidden"
              style={{
                width: '70px',
                height: '26px',
                borderRadius: '8px',
                border: '1px solid #DBDFF1',
                flexShrink: 0,
              }}
            >
              <div
                style={{
                  ...UIHelper.buildFontStyle('500', '14px', 'rgba(114, 114, 139, 1)'),
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flex: 1,
                }}
              >
                DC
              </div>
              <div
                style={{
                  ...UIHelper.buildFontStyle('600', '14px', '#fff'),
                  backgroundColor: 'rgba(48, 189, 111, 1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flex: 1,
                }}
              >
                {`${dcPoints?.length}/${dcPoints?.length}`}
              </div>
            </div>
          </div>
          <div className="d-flex flex-column gap-1">
            <div className="d-flex align-items-start gap-2">
              <i className="fa-solid fa-location-dot py-1" style={{ color: AppColors.primary }} />
              <span style={UIHelper.buildFontStyle('400', '14px', 'rgba(114, 114, 139, 1)')}>
                {ChargeHelper.Utils.getChargeStationFullAddress(station)}
              </span>
            </div>
            <div className="d-flex align-items-start gap-2">
              <i className="fa-solid fa-bolt py-1" style={{ color: AppColors.primary }} />
              <span style={UIHelper.buildFontStyle('400', '14px', 'rgba(114, 114, 139, 1)')}>
                {`${ChargeHelper.Utils.getChargeStationAvailablePoints(station?.chargePoints)}/${station?.chargePoints?.length
                  } Trụ sạc còn trống`}
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* caret */}
      <div className="w-100 bg-transparent h-10px">
        <div
          style={{
            width: 0,
            height: 0,
            borderLeft: '10px solid transparent',
            borderRight: '10px solid transparent',
            borderTop: '10px solid white',
            margin: '0 auto',
          }}
        ></div>
      </div>
    </div>
  );
}

export default StationInfoBoxView;
